<form autocomplete="off" class="form" (submit)="onSubmit($event)">
  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_HOST">{{
      'SMTP_HOST' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="smtpHost"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['smtpHost'])"
        [ngClass]="{ 'is-danger': hasError('smtpHost') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpHost')">
      {{ getError('smtpHost') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_PORT">{{
      'SMTP_PORT' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="smtpPort"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['smtpPort'])"
        [ngClass]="{ 'is-danger': hasError('smtpPort') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpPort')">
      {{ getError('smtpPort') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_USERNAME">{{
      'SMTP_USERNAME' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="smtpUsername"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['smtpUsername'])"
        [ngClass]="{ 'is-danger': hasError('smtpUsername') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpUsername')">
      {{ getError('smtpUsername') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_PASSWORD">{{
      'SMTP_PASSWORD' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="smtpPassword"
        type="password"
        (input)="handleFieldChange($event)"
        [value]="getField(['smtpPassword'])"
        [ngClass]="{ 'is-danger': hasError('smtpPassword') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpPassword')">
      {{ getError('smtpPassword') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_FROMEMAIL">{{
      'SMTP_FROMEMAIL' | translate
    }}</label>
    <div class="control">
      <input
        class="input"
        name="smtpFromEmail"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['smtpFromEmail'])"
        [ngClass]="{ 'is-danger': hasError('smtpFromEmail') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpFromEmail')">
      {{ getError('smtpFromEmail') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="SMTP_REQUIRES_AUTH">{{
      'SMTP_REQUIRES_AUTH' | translate
    }}</label>
    <div class="control">
      <chip
        [checked]="getField(['smtpRequiresAuth'])"
        (onChange)="checkboxChange($event, 'smtpRequiresAuth')"
        [value]="!getField(['smtpRequiresAuth'])"
      >
        <span
          [translationEditableDirective]="
            getField(['smtpRequiresAuth']) ? 'ENABLED' : 'DISABLED'
          "
        >
          {{
            (getField(['smtpRequiresAuth']) ? 'ENABLED' : 'DISABLED')
              | translate
          }}
        </span>
      </chip>
    </div>
    <p class="help is-danger" *ngIf="hasError('smtpRequiresAuth')">
      {{ getError('smtpRequiresAuth') }}
    </p>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-link"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </div>
</form>
